import { Config } from '@shared/configs/config';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Attachment } from '@shared/interfaces/attachment.interface';
import { AuthFilePipe } from '@shared/pipes/authFile.pipe';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ButtonSize, ButtonTypes } from '@shared/modules/ui/components/button/button.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'file-previewer',
  templateUrl: './file-previewer.component.html',
  styleUrls: ['./file-previewer.component.scss']
})
export class FilePreviewerComponent implements OnInit, OnDestroy {
  ButtonSize = ButtonSize;
  ButtonTypes = ButtonTypes;

  downloading: boolean = false;
  src: string | SafeResourceUrl = '';

  constructor(
    private filePipe: AuthFilePipe,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<FilePreviewerComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      file: Attachment;
      downloadFunc: Function;
      isPDF: boolean;
      isVideo: boolean;
    }
  ) {}

  ngOnInit(): void {
    this.setPreviewSrc();
  }

  get videoType(): string {
    const mimeType = this.data?.file?.type?.toLowerCase?.() || '';
    return mimeType.includes('video') ? mimeType : 'video/mp4';
  }

  setPreviewSrc() {
    if (this.data.isVideo) {
      this.src = this.filePipe.transform(this.data.file.file);
      return;
    }

    this.src = (
      this.data.isPDF
        ? this.filePipe.transform(this.data.file.file)
        : this.sanitizer.bypassSecurityTrustResourceUrl(
            Config.GOOGLE_DOCS_LINK(this.filePipe.transform(this.data.file.file))
          )
    ) as string;
  }

  load() {}

  ngOnDestroy() {
    this.src = null;
  }
}
